export default __webpack_public_path__ + "static/media/caret-down.c6768da2.svg";